import { useEffect, useState } from 'preact/hooks';
export function useMediaQuery(query, runOnCleanup) {
    if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined')
        return false;
    const mediaQuery = window.matchMedia(query);
    const [match, setMatch] = useState(!!mediaQuery.matches);
    useEffect(() => {
        const handler = () => setMatch(!!mediaQuery.matches);
        mediaQuery.addListener(handler);
        return () => {
            runOnCleanup instanceof Function && runOnCleanup();
            mediaQuery.removeListener(handler);
        };
    }, []);
    return match;
}
